import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

// components
import FilterItem from '@/braun/components/molecules/FilterItem';

const FiltersList = ({
  open,
  filtersData,
  onChangeFilter,
  onToggleFilters,
  applyFilterLabel,
}) => {
  const wrapperRef = useRef();
  const containerRef = useRef();

  useEffect(() => {
    if (wrapperRef && wrapperRef.current) {
      wrapperRef.current.style.maxHeight = `${containerRef.current
        .offsetHeight + 30}px`;
      setTimeout(
        () => {
          if (open) {
            wrapperRef.current.style.maxHeight = 'none';
          } else {
            wrapperRef.current.removeAttribute('style');
          }
        },
        open ? 351 : 125,
      );
    }
  }, [open]);

  return (
    <div
      ref={wrapperRef}
      className={`bra-toolbarPlp__wrap -filters ${open ? '-open' : ''}`}
    >
      <div ref={containerRef} className='bra-toolbarPlp__filterContainer'>
        {filtersData.facets &&
          filtersData.facets.map(filter => (
            <FilterItem
              key={filter.code}
              filter={filter}
              onChangeFilter={onChangeFilter}
            />
          ))}
        <button
          type='button'
          className='bra-btn bra-btn--rounded bra-btn--apply'
          onClick={onToggleFilters}
        >
          {applyFilterLabel}
        </button>
      </div>
    </div>
  );
};

FiltersList.propTypes = {
  open: PropTypes.bool.isRequired,
  onChangeFilter: PropTypes.func.isRequired,
  filtersData: PropTypes.shape(),
  onToggleFilters: PropTypes.func.isRequired,
  applyFilterLabel: PropTypes.string,
};

FiltersList.defaultProps = {
  filtersData: {},
  applyFilterLabel: 'Apply',
};

export default FiltersList;
